import { useEffect, useState } from "react";
import { useApi, fmtTime } from "../lib/api";
import { PageHeader, Empty } from "../components/common";

export default function Outbox() {
  const api = useApi();
  const [msgs, setMsgs] = useState(null);
  useEffect(() => { api.get("/messages").then((r) => setMsgs(r.data)); }, [api]);
  return (
    <div data-testid="outbox-page">
      <PageHeader overline="WhatsApp · Twilio-ready" title="Message outbox" />
      <div className="mb-6 rounded-md border border-amber-500/40 bg-amber-500/10 text-amber-200 text-sm px-4 py-3" data-testid="whatsapp-mock-banner">
        MOCKED: WhatsApp sending is simulated until your Twilio sender and templates are approved. Every message that would be sent is listed here.
      </div>
      {msgs && msgs.length === 0 && <Empty testid="outbox-empty">No messages yet.</Empty>}
      <div className="space-y-3">
        {(msgs || []).map((m) => (
          <div key={m.id} className="panel p-4" data-testid={`message-${m.id}`}>
            <div className="flex flex-wrap items-center gap-2 text-xs text-slate-400">
              <span className="font-mono text-slate-200">{m.to}</span><span>·</span><span className="uppercase tracking-wider">{m.template}</span>
              <span>·</span><span>{fmtTime(m.ts)}</span>
              <span className={`ml-auto rounded-full px-2 py-0.5 ${m.status === "mocked" ? "bg-amber-500/15 text-amber-300" : m.status === "sent" ? "bg-emerald-500/15 text-emerald-300" : "bg-red-500/15 text-red-300"}`}>{m.status}</span>
            </div>
            <div className="mt-2 text-sm whitespace-pre-wrap break-words">{m.body}</div>
          </div>))}
      </div>
    </div>
  );
}
